<template>
  <OverviewTab
    subtitle="Battery Capacities"
    :descriptions="{
      title: null,
      texts: [
        'The battery Gigafactory concept, Tesla’s Gigafactory 1, became a reality in 2016 and sparked a global battery arms race to shift the world to electric vehicles and energy storage.',
        'These multi-gigawatt hour facilities are an order of magnitude bigger than their predecessors and the impact on the supply chains that feed them has been profound.',
        'Understanding the plans of all current and emerging players in the battery space is crucial to assessing the fate of electric vehicles and reducing the world’s reliance on fossil fuels via energy storage.',
      ],
    }"
    :packages="{
      title: `${MARKET_ASSESSMENTS.singularName} Package`,
      services: [
        {
          icon: 'services/icon-chart-line',
          description:
            'Access to exclusive Battery Cells data, with company and regional capacity, and supply demand/analytics.',
        },
        {
          icon: 'services/icon-report',
          description:
            'Monthly report providing Battery Cell insights and analysis to reveal the direction of the downstream battery sector.',
        },
        {
          icon: 'services/icon-global',
          description:
            'A global perspective on the evolution of the Battery industry.',
        },
        {
          icon: 'services/icon-idea',
          description:
            'Our goal is to help you understand the context of our data, not just give you the numbers.',
        },
      ],
      classes: '',
    }"
    :subscribe="{ checkboxes, methodology }"
  />
</template>

<script setup lang="ts">
import OverviewTab from '~/components/capacity-database/OverviewTab.vue'

import {
  LITHIUM_ION_BATTERIES,
  MARKET_ASSESSMENTS,
  PRICE_ASSESSMENTS,
} from '~/constants/services/constants'
import { CAPACITY_DATABASE_SUBSCRIPTIONS } from '~/src/constants/capacity-database/common'
import type { TFileDownloadInfo } from '~/src/types/download'

const market = LITHIUM_ION_BATTERIES
const ROUTE = '/battery-gigafactory/capacity-database'

definePageMeta({
  isTab: true,
  middleware: async () => {
    const { hasMembership } = useAuthorization()
    const subscription = CAPACITY_DATABASE_SUBSCRIPTIONS[market.slug]
    const isAuthorized = await hasMembership(subscription)

    if (isAuthorized) {
      return navigateTo(`${ROUTE}/battery-cell`)
    }

    return
  },
})

defineProps<{
  checkboxes: string[]
  methodology: TFileDownloadInfo
}>()

const { getSeoInfo } = useSeo()

onMounted(() => {
  const router = useRouter()
  const authStore = useAuthStore()
  const { hasMembership } = useAuthorization()
  const isAuthenticated = computed(() => authStore.authenticated)

  const getIsAuthorized = async () => {
    const subscription = CAPACITY_DATABASE_SUBSCRIPTIONS[market.slug]
    return hasMembership(subscription)
  }

  watch(isAuthenticated, async (isAuthenticated) => {
    if (!isAuthenticated) return

    const isAuthorized = await getIsAuthorized()

    if (isAuthorized) {
      return router.replace(`${ROUTE}/battery-cell`)
    }
  })
})
const seo = getSeoInfo({
  title: `${PRICE_ASSESSMENTS.name}: ${market.name}`,
  description: market.seo.priceAssessments.capacities,
})
useHead(seo)
</script>
